/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {CollectionFactory, Reducer} from '@modifi/redux'
import {FileInfoView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'

const apiClient = getAuthenticatedThemisClient()

const {selectors, reducer, actions} = CollectionFactory({
  reducerPath: ['data', 'personDocuments', 'collection'],
  actionNamePrefix: 'data/personDocuments/collection',
  entityPrimaryKeySelector: (entity: FileInfoView) => entity.fileId!,
  // @ts-expect-error wrong typing in @modifi/redux
  fetchRequest: (state, {externalPersonId}: {externalPersonId: string}) =>
    apiClient.Person.documents({externalPersonId}).then(res => res.data()?.files || []),
})

export default reducer as Reducer

export const selectDocumentsByExternalPersonId = (
  state: Record<string, any>,
  externalPersonId: string
): FileInfoView[] => selectors.selectByKeyWindow(state, {externalPersonId}) as FileInfoView[]

export const aFetchDocumentsByExternalPersonId = (externalPersonId: string): any =>
  actions?.fetch({externalPersonId})
